<template>
  <header>
    <h1>
      <router-link to="/">
        <img src="@assets/img/logo.svg" class="logo" alt="로고" />
      </router-link>
    </h1>
    <div class="btn-header-area">
      <div v-if="!commonStore.isSignIn">
        <router-link :to="{ name: ROUTE_NAME.SignIn }">
          <img src="@assets/img/ic_login.svg" alt="로그인" />
        </router-link>
      </div>
      <div v-if="commonStore.isSignIn">
        <AButton @click="handleSignOut">
          <img src="@assets/img/ic_logout.svg" alt="로그아웃" />
        </AButton>
      </div>
      <!--메뉴버튼-->
      <AButton @click="onMenuClick"
        ><img src="@assets/img/ic_menu.svg" alt="메뉴"
      /></AButton>
    </div>
    <nav :class="{ active: isMenuVisible }">
      <div class="menu-area">
        <ul class="menu-header">
          <li v-if="!commonStore.isSignIn">
            <router-link :to="{ name: ROUTE_NAME.SignIn }">
              <img src="@assets/img/ic_login.svg" alt="로그인" />
            </router-link>
          </li>
          <!--메뉴닫기버튼-->
          <AButton @click="handleClose"
            ><img src="@assets/img/ic_menu_close.svg"
          /></AButton>
        </ul>
        <router-link
          :to="{ name: ROUTE_NAME.Reservation }"
          class="menu-reser"
          @click="handleClose"
        >
          실시간 예약 바로가기
          <img src="@assets/img/ic_menu_arw.svg" />
        </router-link>
        <ul class="menu">
          <li>
            <router-link
              :to="{ name: ROUTE_NAME.ReservationStatus }"
              @click="handleClose"
            >
              전체예약 확인/취소
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: ROUTE_NAME.ReservationWaitStatus }"
              @click="handleClose"
            >
              대기예약 확인/취소
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: ROUTE_NAME.ReservationLotteryStatus }"
              @click="handleClose"
            >
              배정신청 확인/취소
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: ROUTE_NAME.News }" @click="handleClose">
              송추소식
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: ROUTE_NAME.Introduction }"
              @click="handleClose"
            >
              인사말
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: ROUTE_NAME.UserGuide }"
              @click="handleClose"
            >
              이용안내
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: ROUTE_NAME.FeeInfo }"
              @click="handleClose"
            >
              요금안내
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: ROUTE_NAME.CourseFeatures }"
              @click="handleClose"
            >
              코스안내
            </router-link>
          </li>
          <li @click="handleGoWeather()">날씨예보</li>
          <AButton @click="handleCall()">전화하기</AButton>
        </ul>
      </div>
    </nav>
    <!--//메뉴-->
  </header>
</template>

<script setup lang="ts">
import { AButton } from '@atoms';
import { ROUTE_NAME } from '@constants';
import { ref } from 'vue';
import { useSignOut } from '@composables';
import { useCommonStore } from '@stores';

const commonStore = useCommonStore();
const { handleSignOut: signOut } = useSignOut();
const isMenuVisible = ref(false);
const onMenuClick = () => {
  isMenuVisible.value = !isMenuVisible.value;
};

const handleSignOut = async () => {
  await signOut();
  isMenuVisible.value = false;
};

const handleClose = () => {
  isMenuVisible.value = false;
};

const weatherUrl = import.meta.env.VITE_APP_WEATHER_URL;
const handleGoWeather = () => {
  window.open(weatherUrl, '_blank', 'noopener, noreferrer');
};

const handleCall = () => {
  window.location.href = 'tel:0318719410';
};
</script>

<style scoped lang="scss">
header {
  width: 100%;
  position: fixed;
  height: 56px;
  text-align: center;
  background-color: var(--color-main);
  z-index: 10;

  h1 {
    text-align: center;
    padding: 12px 0;

    a {
      display: inline-block;
      vertical-align: middle;
    }

    .logo {
      filter: brightness(0) contrast(100) invert(1);
      height: 33px;
    }
  }
}

.btn-header-area {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 5;
  display: flex;
  align-items: center;
  gap: 0 16px;

  button {
    padding: 0;
    vertical-align: middle;
    filter: brightness(0) contrast(100) invert(1);
    height: 33px;
  }
}

nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  visibility: hidden;
  text-align: center;
  font-size: var(--f18);

  &::before {
    content: '';
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background-color: #222;
  }

  &.active {
    visibility: visible;
  }
}

.menu-area {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 82%;
  background-color: #fff;

  .menu-header {
    position: relative;
    width: 100%;
    height: 56px;
    display: flex;
    justify-content: right;
    align-items: center;
    gap: 0 16px;
    padding-right: 16px;

    button {
      padding: 0;
    }
  }
}

.menu-reser {
  height: 60px;
  padding: 0 3px 0 22px;
  background-color: var(--color-main);
  color: #fff;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.menu {
  height: calc(100vh - 116px);
  overflow-y: auto;

  li {
    text-align: left;
    line-height: 58px;
    border-bottom: 1px solid #eee;
    padding: 0 22px;
  }

  button {
    width: 80%;
    margin: 20px auto;
    background-color: #ecf4ff;
    font-size: var(--f16);
    height: 40px;
  }
}
</style>
